import apiClient from "../api/client";

export const AnalyticsService = {
  // KPIs
  async getKPIs() {
    const response = await apiClient.get("/analytics/kpis/");
    return response;
  },

  async getKPIValues(kpiId: string, params?: any) {
    const response = await apiClient.get(
      `/analytics/valeurs-kpi/?kpi=${kpiId}`,
      { params }
    );
    return response;
  },

  // Tableaux de bord
  async getTableauxBord() {
    const response = await apiClient.get("/analytics/tableaux-bord/");
    return response;
  },

  async getTableauBord(id: string) {
    const response = await apiClient.get(`/analytics/tableaux-bord/${id}/`);
    return response;
  },

  // Rapports
  async getRapports() {
    const response = await apiClient.get("/analytics/rapports/");
    return response;
  },

  async createRapport(data: any) {
    const response = await apiClient.post("/analytics/rapports/", data);
    return response;
  },

  async generateRapport(id: string, params?: any) {
    const response = await apiClient.post(
      `/analytics/rapports/${id}/generate/`,
      params
    );
    return response;
  },

  // Statistiques globales (graphiques, tendances, distribution)
  async getGlobalStats() {
    const response = await apiClient.get("/analytics/stats/global/");
    return response;
  },

  async getClientStats(clientId: string) {
    const response = await apiClient.get(
      `/analytics/stats/client/${clientId}/`
    );
    return response;
  },

  async getFournisseurStats(fournisseurId: string) {
    const response = await apiClient.get(
      `/analytics/stats/fournisseur/${fournisseurId}/`
    );
    return response;
  },

  // Alertes récentes
  async getAlerts() {
    const response = await apiClient.get("/analytics/alerts/");
    return response;
  },
};
